import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { UserContext } from "../../../../context";
import { MainButton } from "../../../atoms";

const ReadyButton: FC<{}> = () => {
	const { t } = useTranslation();
	const { setUserStatus, userData, changePlayerStatusSocketEvent } = useContext(UserContext);

	const changeUserStatus = () => {
		setUserStatus();
		changePlayerStatusSocketEvent();
	}

	// useEffect(() => { // DELETE THIS. THIS IS ONLY FOR TESTING TESTING TESTING TESTING
	// 	changeUserStatus();
	// },[]);

	return (
		<div className="ready_button-position">
			<MainButton type="big" text={t("readyText")} clickHandler={changeUserStatus} disabled={userData?.isReady}/>
		</div>

	);
};

export default ReadyButton;